import { CurrentEditors } from "./";

export class DocumentTokenInformation {
  constructor(
    public token: string,
    public tokenLifeSpan: number,
    public editors: CurrentEditors[],
  ) {
  }
}
